export default [
    {
        key: "spb__lotok_dlya_provodov",
        allArray: "allLotokDlyaProvodov",
        activeArray: "activeLotokDlyaProvodov",
        position: "bottom",
    },
];
